<template>
    <div class="relative h-20 w-full flex items-center justify-center">
        <LoadingState :loading="true" size="medium" :noBackground="true" />
    </div>
</template>

<script>
import LoadingState from '@/components/ui/loading-state/loading-state.vue';

export default {
    name: 'DashboardStatSkeleton',
    components: {
        LoadingState,
    },
};
</script>
